export const handleChangeDataPagesMedicalRecords = (name, value) => ({
    type: 'CHANGE_DATA_PAGES_MEDICAL_RECORDS', name, value
});